// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tag {
    text-align: center;
  }
  
  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }
  
  .Tag-header {
    background-color: #36496D;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  padding-bottom: 20px;
  background-color: #FFFFFF;
  border-radius: 10px;
  box-shadow: #1A2026 0 0 10px;
}

.logo-container > img {
  height: 100%;
}

.id-container {
  position: absolute;
  bottom: 100px;
  border-radius: 10px;
  background-color: #1D2F52;
  padding: 10px 10px;
  box-shadow: #1A2026 0 0 10px;
}
  
  .battery-container {
    margin-top: 20px;
    color: #cdc0c0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .battery-bar {
    width: 300px;
    height: 30px;
    background-color: #eee;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
  }
  
  .battery-fill {
    height: 100%;
    background: linear-gradient(90deg, #f1c40f, #4caf50);
    background-size: 200% 100%;
    animation: progressAnimation 2s linear infinite;
  }
  
  .loading-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #333;
  }
  
  /* Styled button */
  .connect-button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: #61dafb;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 20px;
  }
  
  .connect-button.hidden {
    display: none;
  }
  
  .connect-button:hover {
    background-color: #4fa3d1;
  }
  
  @keyframes progressAnimation {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Tag/Tag.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;EACd;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;EAEE;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,oDAAoD;IACpD,0BAA0B;IAC1B,+CAA+C;EACjD;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;EACb;;EAEA,kBAAkB;EAClB;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,4BAA4B;IAC9B;EACF","sourcesContent":[".Tag {\n    text-align: center;\n  }\n  \n  .App-logo {\n    height: 40vmin;\n    pointer-events: none;\n  }\n  \n  .Tag-header {\n    background-color: #36496D;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  }\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100px;\n  padding-bottom: 20px;\n  background-color: #FFFFFF;\n  border-radius: 10px;\n  box-shadow: #1A2026 0 0 10px;\n}\n\n.logo-container > img {\n  height: 100%;\n}\n\n.id-container {\n  position: absolute;\n  bottom: 100px;\n  border-radius: 10px;\n  background-color: #1D2F52;\n  padding: 10px 10px;\n  box-shadow: #1A2026 0 0 10px;\n}\n  \n  .battery-container {\n    margin-top: 20px;\n    color: #cdc0c0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .battery-bar {\n    width: 300px;\n    height: 30px;\n    background-color: #eee;\n    border-radius: 5px;\n    overflow: hidden;\n    position: relative;\n  }\n  \n  .battery-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #f1c40f, #4caf50);\n    background-size: 200% 100%;\n    animation: progressAnimation 2s linear infinite;\n  }\n  \n  .loading-text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #333;\n  }\n  \n  /* Styled button */\n  .connect-button {\n    padding: 10px 20px;\n    font-size: 16px;\n    background-color: #61dafb;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 20px;\n  }\n  \n  .connect-button.hidden {\n    display: none;\n  }\n  \n  .connect-button:hover {\n    background-color: #4fa3d1;\n  }\n  \n  @keyframes progressAnimation {\n    0% {\n      background-position: 200% 0;\n    }\n    100% {\n      background-position: -200% 0;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
